import { useCallback } from 'react';
import { useSelector } from 'react-redux';
const useConnectionCardVisibility = () => {
  const {
    env: {
      app
    },
    config: {
      connectedAppsSupportedCountries
    },
    auth: {
      user: {
        country
      }
    }
  } = useSelector(state => state);
  const isLibre = app === 'libre1';
  const isAvailable = useCallback(codes => Boolean(isLibre && codes?.includes(country.toUpperCase())), [country, isLibre]);
  return {
    isLibre,
    showPractice: isAvailable(connectedAppsSupportedCountries?.libreview),
    showDataShare: isAvailable(connectedAppsSupportedCountries?.datashare),
    showPartner: isLibre,
    showCaregiver: app === 'insulet' || isAvailable(connectedAppsSupportedCountries?.linkup)
  };
};
export default useConnectionCardVisibility;